import React from 'react';

type Props = {
    children: React.ReactNode;
};

/**
 * The camera-off card, laid over a tile's `<video>` (VID-502). The `<video>`
 * stays mounted underneath so it can decode, and this layer covers it until
 * the first frame arrives, so the tile's layout doesn't change when the video
 * appears. It carries its own gray card and avatar size container, so the
 * avatar looks the same whether or not the tile beneath it is one.
 */
const MeetingTileAvatarLayer = ({ children }: Props) => (
    <div className="meeting-tile-avatar-container absolute inset-0 flex items-center justify-center bg-gray-800">
        {children}
    </div>
);

export default MeetingTileAvatarLayer;
